import { appstr } from "../utils/appstr";
import { Div2Floor } from "../utils/Div2Floor";
import {
  enumButtonIconPosition,
  enumElementDrawStates,
  enumFontIconWeights,
  kArrowRightIcon,
  kCheckIcon,
  kFramelessDropDownMarginH,
  kGreen,
  kPremiumPaywallHighlightColor,
  kToggleOffIconDuo,
  kToggleOnIcon
} from "../constants";
import { uFramelessPanelColor, uFramelessPanelColorDarker } from "../whitelabel/brand";
import { fontIconStringDuotone } from "../utils/fontIconStringDuotone";
import { QButton } from "./QButton";
import { shadeColor } from "../utils/shadeColor";
import { TruncateText } from "../utils/TruncateText";
import { SetCtxFont } from "../utils/SetCtxFont";
import { MeasureText } from "../utils/MeasureText.js";
import { MeasureTextHeight } from "../utils/MeasureTextHeight.js";
import { Globals } from "./Globals.js";
import { fontIconString } from "../utils/fontIconString.js";

export class QDropDownElement extends QButton {
  constructor() {
    super();
    this.fName = "";
    this.fTruncName = "";
    this.fTruncValue = "";
    this.fToggle = null;
    this.fCurValue = null;
    this.fIsActive = false;
    this.fIsGoCmd = false;
    this.fHoverTip = null;
    this.fOverrideTextColor = null;
  }

  GenerateAdditionalCmdParameters() {
    if (!this.fAdditionalCmdParameters) this.fAdditionalCmdParameters = {};
    if (this.fAdditionalCmdParameters["sourceValue"] == null)
      this.AddCmdParameter("sourceValue", this.fName);
    if (this.fAdditionalCmdParameters["newindex"] == null)
      this.AddCmdParameter("newindex", this.fButtonIndex);
    if (this.fAdditionalCmdParameters["index"] == null)
      this.AddCmdParameter("index", this.fParentPanelRef.fBackgroundPanel.fIndex);
  }

  SetName(theName) {
    var hOffset = 6;
    theName = this.ProcessName(theName);
    this.fName = theName;
    var maxWidth = this.GetWidth() - 2 * hOffset;
    if (this.fIconPosition === enumButtonIconPosition.right) maxWidth -= 35;
    if (this.fIsGoCmd) maxWidth -= 10;
    if (this.fToggle) maxWidth -= 10;
    //maxWidth = this.fIsGoCmd ? maxWidth - 6*kFramelessDropDownMarginH : maxWidth;
    var textW = MeasureText(theName, this.fFontString);
    if (textW > maxWidth) {
      this.SetRawHoverValue(theName);
    }
    this.fTruncName = TruncateText(theName, this.fFontString, maxWidth);
  }

  SetNameExplicit(theName) {
    theName = this.ProcessName(theName);

    var maxWidth = this.GetWidth() - 2 * kFramelessDropDownMarginH;
    if (this.fIconPosition === enumButtonIconPosition.right) maxWidth -= 20;
    if (this.fIsGoCmd) maxWidth -= 10;
    if (this.fToggle) maxWidth -= 10;
    //maxWidth = this.fIsGoCmd ? maxWidth - 6*kFramelessDropDownMarginH : maxWidth;
    var textW = MeasureText(theName, this.fFontString);
    if (textW > maxWidth) {
      this.SetRawHoverValue(theName);
    }
    this.fTruncName = TruncateText(theName, this.fFontString, maxWidth);
  }

  ProcessName(name) {
    // override this for unique handling
    return name;
  }

  SetToggleName() {
    var txtoffset = 4;
    if (typeof this.fCurValue === "boolean") {
      var maxWidth = this.GetWidth() - 2 * txtoffset - 34;
      this.fTruncName = TruncateText(this.fTruncName, this.fFontString, maxWidth);
      var textW = MeasureText(this.fName, this.fFontString);
      if (textW > maxWidth) {
        this.SetRawHoverValue(this.fName);
      }
    } else {
      var curValue = this.fCurValue;
      var maxWidth =
        this.GetWidth() - 4 * txtoffset - MeasureText(this.fTruncName, this.fFontString);
      this.fTruncValue = TruncateText(curValue, this.fFontString, maxWidth);
      var textW = MeasureText(curValue, this.fFontString);
      if (textW > maxWidth) {
        this.SetRawHoverValue(curValue);
      }
    }
  }

  DoEnterKeyboardTarget(enterAction) {
    this.fParent.DoHighlightElement(this, true);
  }

  DoRenderContent(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    var r2d = Math.PI / 180;
    var r = 4;

    var panelColors = this.fParent.fBackgroundPanel.GetPanelColors();
    var bodyTextColor = panelColors["text"];

    var textColor = bodyTextColor;
    var buttonColor = textColor;
    var parent = this.fParent;

    var selected = this.fIsActive || this.fSelected;
    var fs = this.fFontString;

    SetCtxFont(ctx, fs);
    var txtFillStyle = textColor;
    if (this.fOverrideTextColor != null) txtFillStyle = this.fOverrideTextColor;

    var theLabel =
      this.fIsPaywall && this.GetDrawState() === enumElementDrawStates.Hover
        ? appstr("paywallhover")
        : this.fTruncName;

    switch (this.GetDrawState()) {
      case enumElementDrawStates.Disabled:
        if (!this.fIsDividerText) {
          ctx.globalAlpha = 0.6;
          txtFillStyle = shadeColor(bodyTextColor, -5);
        }
      case enumElementDrawStates.Std:
      case enumElementDrawStates.MouseDown:
      case enumElementDrawStates.Hover:
        if (this.fIsPaywall && this.GetDrawState() === enumElementDrawStates.Hover) {
          txtFillStyle = kPremiumPaywallHighlightColor;
        }
        break;
    }

    var txtHOffset = kFramelessDropDownMarginH;
    var labelX = this.fHorzOffset + txtHOffset;
    var labelY = this.fVertOffset;
    var txtVOffset = this.fVertOffset + Math.ceil(Div2Floor(this.GetHeight())) + 1;

    ctx.textBaseline = "middle";
    ctx.fillStyle = txtFillStyle;

    if (selected) {
      ctx.save();
      this.DrawFontIcon(
        ctx,
        labelX,
        labelY,
        kCheckIcon,
        5,
        txtFillStyle,
        enumButtonIconPosition.left,
        null,
        null,
        true
      );
      ctx.restore();
    }

    if (this.fToggle) {
      var toggleHeight = MeasureTextHeight("18px Arial", 18); // We can either make it a property you can set, or keep it static
      var toggleVOffset = Div2Floor(this.fHeight - toggleHeight);

      ctx.save();
      ctx.fillStyle = txtFillStyle;
      ctx.textAlign = "left";

      if (this.fIcon) {
        if (this.fIconPosition === enumButtonIconPosition.left) txtHOffset += 8;
        this.DrawFontIcon(
          ctx,
          labelX,
          labelY,
          this.fIcon,
          txtHOffset,
          buttonColor,
          this.fIconPosition
        );
        var labelOffset = 28;
      } else var labelOffset = 6;

      if (this.fContentRows != null) {
        var rowOffset = 0;
        var n = this.fContentRows.length;
        for (var i = 0; i < n; i++) {
          var txt = this.fContentRows[i];
          ctx.fillText(
            txt,
            this.fHorzOffset + txtHOffset,
            this.fVertOffset + toggleVOffset + rowOffset
          );
          rowOffset += 18;
        }
      } else {
        ctx.fillText(
          theLabel,
          this.fHorzOffset + labelOffset,
          txtVOffset,
          this.fWidth - (this.fHorzOffset + labelOffset)
        );
      }

      ctx.restore();

      if (typeof this.fCurValue === "boolean") {
        var isOn = this.fCurValue === true;
        var toggleIcon = isOn ? kToggleOnIcon : kToggleOffIconDuo;
        var toggleColor = this.fEnabled
          ? isOn
            ? kGreen
            : Globals._themeMode.border
          : Globals._themeMode.lightborder;
        if (this.fUseTheme) toggleColor = txtFillStyle;
        var weight = enumFontIconWeights.regular;
        var size = 20;
        var style = isOn ? fontIconString(size, weight) : fontIconStringDuotone(size);
        if (!isOn) labelY = labelY - 6;
        ctx.save();
        this.DrawFontIcon(
          ctx,
          labelX,
          labelY,
          toggleIcon,
          txtHOffset,
          toggleColor,
          enumButtonIconPosition.right,
          style,
          size
        );
        ctx.restore();
      } else {
        var label2 = this.fTruncValue;
        var labelOffset = 6;
        ctx.save();
        ctx.fillStyle = txtFillStyle;
        ctx.textAlign = "right";
        ctx.fillText(label2, this.fHorzOffset + this.fWidth - labelOffset, txtVOffset);
        ctx.restore();
      }
    } else {
      if (!this.fDoubleSize) {
        var goOffset = this.fIsGoCmd ? 20 : 0;
        if (!this.fIsDividerText) txtHOffset += 8;
        if (this.fIcon) {
          this.DrawFontIcon(
            ctx,
            labelX,
            labelY,
            this.fIcon,
            txtHOffset,
            buttonColor,
            this.fIconPosition
          );
        }

        ctx.fillText(
          theLabel,
          this.fHorzOffset + txtHOffset,
          txtVOffset,
          this.fWidth - (this.fHorzOffset + txtHOffset + goOffset)
        );
      } else {
        ctx.textAlign = "left";
        if (this.fIsPaywall) ctx.fillStyle = kPremiumPaywallHighlightColor;
        ctx.textAlign = "center";
        var splitString = this.fName.split("-");
        var topString = splitString[0];
        var bottomString = splitString[1];
        ctx.fillText(topString, this.fHorzOffset + this.fWidth / 2, txtVOffset - 8);
        ctx.textBaseline = "middle";
        ctx.fillText(bottomString, this.fHorzOffset + this.fWidth / 2, txtVOffset + 8);
        ctx.textBaseline = "middle";
      }

      var drawGoButton = this.fIsGoCmd && this.GetDrawState() === enumElementDrawStates.Hover;
      if (drawGoButton) {
        ctx.save();
        this.DrawFontIcon(
          ctx,
          labelX,
          labelY,
          kArrowRightIcon,
          txtHOffset,
          buttonColor,
          enumButtonIconPosition.right
        );
        ctx.restore();
      }
    }
  }

  DrawPad(drawBuffer, mouseDown) {
    var ctx = drawBuffer.getContext("2d");
    var padColor = this.fUIColors.GetAlternativePanelFillColor();
    ctx.strokeStyle = this.fUIColors.GetAlternativeTextColor();
    ctx.lineWidth = 1;

    var selected = this.fIsActive || this.fSelected;
    var color = this.fUseTheme ? uFramelessPanelColor : this.fUIColors.GetButtonFillColor();
    var fill;

    ctx.globalAlpha = this.fUseTheme ? 1 : this.fUIColors.InDarkMode() ? 0.7 : 0.3;

    if (this.fUseTheme) {
      fill = color;
      if (!selected) fill = uFramelessPanelColorDarker;
    } else {
      if (mouseDown || selected) {
        // light option as selected or mouse down
        fill = shadeColor(color, 4);
      } else if (this.fIsHighlighted) {
        // promote highlighted option
        fill = shadeColor(color, -2);
      } else {
        // default
        fill = color;
      }
    }

    ctx.fillStyle = fill;
    ctx.fill(this.fClippedRegion);

    if (this.fIsHighlighted) {
      ctx.globalAlpha = 1;
      ctx.strokeStyle = this.fUIColors.GetButtonBorderColor();
      ctx.stroke(this.fClippedRegion);
    }
    ctx.globalAlpha = 1;
  }

  GetCursor() {
    return "pointer";
  }

  GetRealContent() {
    return this.fName;
  }

  GetListID() {
    return this.fParent.GetListID();
  }

  GetListElementID() {
    return false;
  }

  RenderSelectionHighlight() {}
}
